import React, { useEffect, useRef, useMemo } from 'react';
import { autoScrollForElements } from '@atlaskit/pragmatic-drag-and-drop-auto-scroll/element';
import BoardColumn from './BoardColumn';
import AddNewStage from './AddNewStage';
import { useBoardData } from '../context/BoardContext';
import { useFilters } from '../context/FilterContext';

const KanbanBoard = () => {
  const boardScrollRef = useRef(null);
  const { leadStages } = useBoardData();
  const filters = useFilters();

  // Build filter object for columns - memoized to prevent breaking child memoization
  const filterParams = useMemo(
    () => ({
      searchKeyword: filters.searchKeyword,
      practiceArea: filters.practiceArea,
      assignedTo: filters.assignedTo,
      sortType: filters.sortType,
    }),
    [filters.searchKeyword, filters.practiceArea, filters.assignedTo, filters.sortType]
  );

  useEffect(() => {
    const cleanups = [];

    if (boardScrollRef.current) {
      cleanups.push(
        autoScrollForElements({
          element: boardScrollRef.current,
          canScroll: ({ source }) => source.data.type === 'card' || source.data.type === 'column',
        })
      );
    }

    cleanups.push(
      autoScrollForElements({
        element: document.documentElement,
      })
    );

    return () => {
      cleanups.forEach((cleanup) => cleanup());
    };
  }, []);

  return (
    <div className="d-flex">
      <div className="kanban-board thin-scrollbar" ref={boardScrollRef}>
        <div className="board-scroll-container">
          {leadStages?.map((column, index) => (
            <BoardColumn key={column.sk} column={column} index={index} filters={filterParams} />
          ))}
          <AddNewStage />
        </div>
      </div>
    </div>
  );
};

// Memoize with custom comparison - only rerender if columns array changes
export default KanbanBoard;
